export default {
    lang: {
        name: 'Group rating'
    }
}